/* eslint-disable max-lines-per-function */
import React, { useEffect, useState } from "react"
import { ScoreboardWrapper, ScoreboardsWrapper } from "./styled"
import { BOARD_SWAP_INTERVAL } from "/src/constants"
import Scoreboard from "/src/components/Quiz/Scoreboard"
import { useSelector } from "react-redux"

const Leaderboard = () => {

  const {
    isFinalScore,
    questionScores,
    skin,
    totalPlayers,
    totalScores,
  } = useSelector(state => state.game)

  const [activeBoardIndex, setActiveBoardIndex] = useState(0)

  const scoreboards = !isFinalScore ? [
    {
      color: skin.colors.roundLeaderboard,
      entries: questionScores,
      playerCount: totalPlayers,
      title: "Question Scores"
    },
    {
      color: skin.colors.totalLeaderboard,
      entries: totalScores,
      playerCount: totalPlayers,
      title: "Total Scores"
    },
  ] : [
    {
      color: skin.colors.finalLeaderboard,
      entries: totalScores,
      playerCount: totalPlayers,
      title: "Endergebnis"
    }
  ]

  // Colors shared by all scoreboard variants
  const commonColors = {
    highlight: skin.colors.highlight,
    primaryFont: skin.colors.primaryFont,
    secondary: skin.colors.secondary,
    variables: skin.colors.variables
  }

  // Swap which scoreboard is active (on top) at regular intervals
  useEffect(() => {
    setTimeout(
      () => setActiveBoardIndex((activeBoardIndex + 1) % scoreboards.length),
      BOARD_SWAP_INTERVAL
    )
  }, [activeBoardIndex])

  return (
    <ScoreboardsWrapper>
      {
        scoreboards.map((scoreboard, i) => (
          <ScoreboardWrapper
            active={activeBoardIndex === i}
            key={scoreboard.title}
          >
            <Scoreboard
              colors={{
                ...commonColors,
                leaderboard: scoreboard.color,
              }}
              entries={scoreboard.entries}
              playerCount={totalPlayers}
              title={scoreboard.title}
            />
          </ScoreboardWrapper>
        ))
      }
    </ScoreboardsWrapper>
  )
}

export default Leaderboard
